import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { _onToogleIsDirty } from "../redux/actions/generalAction";

const usePreventBackNavigation = () => {
  const isDirty = useSelector((state) => state.general.isDirty || false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const hasCanceledBack = useRef(false); // Track if user canceled before

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = ""; // Prevent default alert
      }
    };

    const handleBackButton = (event) => {
      if (isDirty) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes. Do you really want to leave?"
        );

        if (confirmLeave) {
          dispatch(_onToogleIsDirty(false)); // Reset isDirty
          navigate(-1); // Go back normally
        } else {
          hasCanceledBack.current = true; // Mark that user canceled
          window.history.pushState(
            null,
            "",
            location.pathname + location.search
          );
        }
      } else {
        if (hasCanceledBack.current) {
          hasCanceledBack.current = false; // Reset flag
          navigate("/dental-identification/dashboard", { replace: true }); // ✅ Always redirect to dashboard
        }
      }
    };

    // Prevent native back navigation when isDirty is true
    if (isDirty) {
      window.history.pushState(null, "", location.pathname + location.search);
    }

    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty, dispatch, navigate, location.pathname, location.search]);

  return null;
};

export default usePreventBackNavigation;
